'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _dec2, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _reactLoader = require('react-loader');

var _reactLoader2 = _interopRequireDefault(_reactLoader);

var _ = require('../');

var _RetirementPlanTable = require('./RetirementPlanTable.css');

var _RetirementPlanTable2 = _interopRequireDefault(_RetirementPlanTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO UI BASICS
// √ filter clear button
// √ table sorting
// √ filter debounce
//  + loading spinner while typing
//    for 1.5 seconds after
// √ styling
// √ mobile table

// TODO table content
// √ # of ESG options?
// √ has self-directed?
// screen results ?


var RetirementPlanTableThSortIcons = (_dec = (0, _reactCssModules2.default)(_RetirementPlanTable2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(RetirementPlanTableThSortIcons, _Component);

  function RetirementPlanTableThSortIcons(props) {
    (0, _classCallCheck3.default)(this, RetirementPlanTableThSortIcons);
    return (0, _possibleConstructorReturn3.default)(this, (RetirementPlanTableThSortIcons.__proto__ || (0, _getPrototypeOf2.default)(RetirementPlanTableThSortIcons)).call(this, props));
  }

  (0, _createClass3.default)(RetirementPlanTableThSortIcons, [{
    key: 'render',
    value: function render() {
      //
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { styleName: this.props.active && this.props.asc ? 'th-icon-active' : 'th-icon' },
          _react2.default.createElement(_.LinkIcon, { faclass: 'fa-caret-up', nospace: true })
        ),
        _react2.default.createElement(
          'div',
          { styleName: this.props.active && !this.props.asc ? 'th-icon-active' : 'th-icon' },
          _react2.default.createElement(_.LinkIcon, { faclass: 'fa-caret-down', nospace: true })
        )
      );
    }
  }]);
  return RetirementPlanTableThSortIcons;
}(_react.Component)) || _class);
var RetirementPlanTable = (_dec2 = (0, _reactCssModules2.default)(_RetirementPlanTable2.default, { allowMultiple: true }), _dec2(_class2 = (_temp = _class3 = function (_Component2) {
  (0, _inherits3.default)(RetirementPlanTable, _Component2);

  function RetirementPlanTable(props) {
    (0, _classCallCheck3.default)(this, RetirementPlanTable);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (RetirementPlanTable.__proto__ || (0, _getPrototypeOf2.default)(RetirementPlanTable)).call(this, props));

    _this2.calcPercAllocDefault = function (company) {
      return company.plan_assets ? company.allocations.default / company.plan_assets : -1;
    };

    _this2.calcPercAllocSri = function (company) {
      return company.plan_assets ? company.allocations.sri / company.plan_assets : -1;
    };

    _this2.calcHasSelfDirected = function (company) {
      return company.access_self_directed.length > 0 ? 1 : 0;
    };

    _this2.resetCompanies = function () {
      var companies = (0, _keys2.default)(_config2.default.plansSource).map(function (key, i) {
        //
        var company = _config2.default.plansSource[key];

        // calculate values for table sort
        company.percAllocDefault = _this2.calcPercAllocDefault(company);
        company.percAllocSri = _this2.calcPercAllocSri(company);
        company.hasSelfDirected = _this2.calcHasSelfDirected(company);

        var companyWithPath = {
          company: company,
          path: key
        };
        return companyWithPath;
      });

      return companies;
    };

    _this2.sortCompanies = function (companies, sortVal) {
      var noFlipAsc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      // default and secondary sort is short_name
      var defaultSortOnField = 'primary_plan_name';

      // are we clicking the column header of the existing sort?
      // if so, we want to switch ascending/descending.
      // unless we are asked not to switch it,
      // because we are being called from the filter function.
      var currAsc = _this2.state.sortAsc;
      if (_this2.state.sortVal === sortVal && !noFlipAsc) {
        currAsc = !currAsc;
      }

      // sort logic here
      // what are we going to use to sort?
      var currSort = _this2.state.sortVals[sortVal];
      var sortOnField = currSort[1];
      // const sortAsNumbers = currSort[2]

      function compareFn(_a, _b, _sortOnField) {
        if (_a.company[_sortOnField] === _b.company[_sortOnField]) return 0;
        return _a.company[_sortOnField] > _b.company[_sortOnField] ? 1 : -1;
      }

      function compareByDefaultSort(a, b) {
        return compareFn(a, b, defaultSortOnField);
      }

      function compareBySortVal(a, b) {
        return currAsc ? compareFn(a, b, sortOnField) : compareFn(b, a, sortOnField);
      }

      // first, default sort by name ascending
      companies.sort(compareByDefaultSort);
      // next, sort on requested sort
      if (currSort !== defaultSortOnField) {
        companies.sort(compareBySortVal);
      }

      return [companies, currAsc];
    };

    _this2.filterCompanies = function (filterVal) {
      // first, we filter a fresh set of companies
      var companies = _this2.resetCompanies().filter(function (e, i) {
        if (filterVal && filterVal.length >= 3) {
          if (e.company.primary_plan_name.toUpperCase().includes(filterVal.toUpperCase()) || e.company.short_name.toUpperCase().includes(filterVal.toUpperCase())) {
            return true;
          }
        } else {
          return true;
        }
        return false;
      });

      // then, we sort the filtered companies
      // using the current saved Sort,
      // and not flipping the ascending.
      var sortedCompanyConfig = _this2.sortCompanies(companies, _this2.state.sortVal, true);

      return sortedCompanyConfig[0];
    };

    _this2.sortTable = function (sortVal) {
      var sortedCompanyConfig = _this2.sortCompanies(_this2.state.companies, sortVal);
      _this2.setState({
        companies: sortedCompanyConfig[0],
        sortAsc: sortedCompanyConfig[1],
        sortVal: sortVal
      });
    };

    _this2.filterTable = function (filterVal) {
      if (_this2.sortFilterTimeout) {
        clearTimeout(_this2.sortFilterTimeout);
      }

      if (filterVal && filterVal.length >= 3) {
        _this2.setState({
          filterVal: filterVal,
          loading: true,
          sortFilterTimeout: setTimeout(function () {
            var filteredCompanies = _this2.filterCompanies(filterVal);
            _this2.setState({
              loading: false,
              companies: filteredCompanies
            });
          }, _this2.state.debounceTime)
        });
      } else {
        var filteredCompanies = _this2.filterCompanies(filterVal);
        _this2.setState({
          filterVal: filterVal,
          loading: false,
          companies: filteredCompanies
        });
      }
    };

    _this2.formatNameLink = function (e) {
      return _react2.default.createElement(
        _.Link,
        {
          to: _config2.default.routes.plans + '/' + e.path,
          title: e.company.primary_plan_name
        },
        e.company.primary_plan_name
      );
    };

    _this2.formatPlanAssets = function (e) {
      return e.company.plan_assets ? _format2.default.money(e.company.plan_assets, true, 'USD', true, 1) : 'N/A';
    };

    _this2.formatPercAllocDefault = function (e) {
      return e.company.percAllocDefault >= 0 ? _format2.default.perc(e.company.percAllocDefault) : 'N/A';
    };

    _this2.formatSriCount = function (e) {
      return e.company.plan_option_sri_count > 0 ? e.company.plan_option_sri_count : _react2.default.createElement(
        'span',
        { styleName: 'red' },
        e.company.plan_option_sri_count
      );
    };

    _this2.formatPercAllocSri = function (e) {
      return e.company.percAllocSri >= 0 ? _format2.default.perc(e.company.percAllocSri) : 'N/A';
    };

    _this2.formatHasSelfDireceted = function (e) {
      return e.company.hasSelfDirected ? _react2.default.createElement(_.LinkIcon, { faclass: 'fa-check' }) : _react2.default.createElement(
        'span',
        { styleName: 'red' },
        _react2.default.createElement(_.LinkIcon, { faclass: 'fa-times' })
      );
    };

    _this2.state = {
      sortVals: [
      // [Table label, field name, 0/1 for string/number]
      ['Plan', 'primary_plan_name'], // , 0
      ['Assets', 'plan_assets'], // , 1
      ['# of sustainable funds', 'plan_option_sri_count'], // , 1
      ['% in sustainable funds', 'percAllocSri'], // , 1
      ['Target date manager', 'default_fund_manager'], // , 0
      ['% in target date', 'percAllocDefault'], // , 1
      ['Self-directed option?', 'hasSelfDirected'] // , 1
      ],
      companies: _this2.resetCompanies(),
      sortVal: 0,
      sortAsc: true,
      filterVal: '',
      sortFilterTimeout: null,
      loading: false,
      debounceTime: 500
    };
    return _this2;
  }

  // core logic to filter companies
  // includes sorting logic


  // these two functions are called by user interaction with table elements
  // they serve as wrappers for the logic of sorting and filtering


  // filter table has a debounce timeout


  (0, _createClass3.default)(RetirementPlanTable, [{
    key: 'render',
    value: function render() {
      var _this3 = this;

      //
      return _react2.default.createElement(
        _.ContainerDivs,
        null,
        _react2.default.createElement(
          'div',
          { styleName: 'cs-out' },
          _react2.default.createElement(
            'div',
            { styleName: 'filter-and-table-wrap' },
            _react2.default.createElement(
              'div',
              { styleName: 'filter-and-table-wrap-inner' },
              _react2.default.createElement(
                'label',
                { styleName: 'filter-input-label', htmlFor: 'company-table-filter' },
                _react2.default.createElement(
                  _.SrOnly,
                  null,
                  'Search employers by name'
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'filter-input-wrap' },
                _react2.default.createElement('input', {
                  styleName: 'filter-input-input',
                  value: this.state.filterVal,
                  onChange: function onChange(e) {
                    return _this3.filterTable(e.target.value);
                  },
                  placeholder: 'Search employers',
                  id: 'company-table-filter',
                  name: 'company-table-filter'
                }),
                _react2.default.createElement('div', {
                  styleName: 'submit',
                  className: 'fa fa-search'
                }),
                _react2.default.createElement(
                  'button',
                  {
                    onClick: function onClick(e) {
                      return _this3.filterTable('');
                    },
                    styleName: 'filter-input-clear-btn'
                  },
                  'Clear'
                )
              ),
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'table',
                { styleName: 'company-table' },
                _react2.default.createElement(
                  'thead',
                  null,
                  _react2.default.createElement(
                    'tr',
                    null,
                    this.state.sortVals.map(function (e, i) {
                      return _react2.default.createElement(
                        'th',
                        {
                          onClick: function onClick() {
                            return _this3.sortTable(i);
                          },
                          key: 'company-table-th-' + i,
                          styleName: 'company-table-th-' + e[1]
                        },
                        _react2.default.createElement(
                          'div',
                          { styleName: 'company-table-th-inner' },
                          e[0],
                          _react2.default.createElement(RetirementPlanTableThSortIcons, {
                            active: _this3.state.sortVal === i,
                            asc: _this3.state.sortAsc
                          })
                        )
                      );
                    })
                  )
                ),
                this.state.loading ? _react2.default.createElement(
                  'tbody',
                  null,
                  _react2.default.createElement(
                    'tr',
                    { styleName: 'loader-tr' },
                    _react2.default.createElement(
                      'td',
                      { colSpan: '7', styleName: 'loader-td' },
                      _react2.default.createElement(
                        'div',
                        { styleName: 'loader-wrap' },
                        _react2.default.createElement(_reactLoader2.default, { options: { scale: 1, top: '50%' } })
                      )
                    )
                  )
                ) : _react2.default.createElement(
                  'tbody',
                  null,
                  this.state.companies.map(function (e, i) {
                    return _react2.default.createElement(
                      'tr',
                      { key: 'cmpny-' + i },
                      _react2.default.createElement(
                        'td',
                        { 'data-label': 'Employer' },
                        _this3.formatNameLink(e)
                      ),
                      _react2.default.createElement(
                        'td',
                        { style: { textAlign: 'right' }, 'data-label': 'Plan assets' },
                        _this3.formatPlanAssets(e)
                      ),
                      _react2.default.createElement(
                        'td',
                        { style: { textAlign: 'right' }, 'data-label': '# of sustainable funds' },
                        _this3.formatSriCount(e)
                      ),
                      _react2.default.createElement(
                        'td',
                        { style: { textAlign: 'right' }, 'data-label': '% in sustainable funds' },
                        _this3.formatPercAllocSri(e)
                      ),
                      _react2.default.createElement(
                        'td',
                        { 'data-label': 'Target date manager' },
                        e.company.default_fund_manager
                      ),
                      _react2.default.createElement(
                        'td',
                        { style: { textAlign: 'right' }, 'data-label': '% in target date option' },
                        _this3.formatPercAllocDefault(e)
                      ),
                      _react2.default.createElement(
                        'td',
                        { style: { textAlign: 'right' }, 'data-label': 'Self-directed option?' },
                        _this3.formatHasSelfDireceted(e)
                      )
                    );
                  })
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'cs-tl-sub' },
            'New plans added regularly'
          )
        )
      );
    }
  }]);
  return RetirementPlanTable;
}(_react.Component), _class3.contextTypes = {
  router: _react.PropTypes.object.isRequired
}, _temp)) || _class2);
exports.default = RetirementPlanTable;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/RetirementPlanTable/RetirementPlanTable.js
// module id = 1437
// module chunks = 0